import {
  findByProductName,
  resetFilters,
  setFilterOpen,
  setLeftSidebarOpen,
  setPagination,
  setProductName,
  setSelectedBrands,
  setSelectedCategory,
  setSelectedPrice,
  setSidebarpopup,
  updateFilters,
  updateOrder,
} from "@redux/slice/filter";
import { RootState } from "@redux/store";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useFilters = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const filterState = useSelector((state: RootState) => state.filter);

  // Initialize filters from URL when component mounts
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!filterState.filtersModified) return;
    const params = new URLSearchParams();

    params.set("page", filterState.pagination.page.toString());
    if (filterState.pagination.limit !== 12) {
      params.set("limit", filterState.pagination.limit.toString());
    }

    Object.entries(filterState.filters).forEach(([key, value]) => {
      if (
        key !== "page" &&
        key !== "limit" &&
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {
        params.set(key, value.toString());
      }
    });

    if (filterState.order.order !== "ASC") {
      params.set("order", filterState.order.order);
    }

    if (filterState.order.field !== "price") {
      params.set("field", filterState.order.field);
    }

    const currentUrl = window.location.search;
    const newUrl = `?${params.toString()}`;
    if (currentUrl !== newUrl) {
      router.push(newUrl);
    }
  }, [filterState.filters, filterState.order, filterState.pagination, router]);

  const handlePagination = (key: "page" | "limit", value: number) => {
    dispatch(setPagination({ key, value }));
  };

  const handleProductName = (name: string) => {
    dispatch(setProductName(name));
  };

  const handleUpdateFilters = (
    key: keyof Filters,
    value: string | number | number[] | null
  ) => {
    dispatch(updateFilters({ key, value }));
  };

  const handleUpdateOrder = (newOrder: Partial<Order>) => {
    dispatch(updateOrder(newOrder));
  };

  const handleFilterOpen = (isOpen: boolean) => {
    dispatch(setFilterOpen(isOpen));
  };

  const handleLeftSidebarOpen = () => {
    dispatch(setLeftSidebarOpen());
  };

  const handleSidebarpopup = (isOpen: boolean) => {
    dispatch(setSidebarpopup(isOpen));
  };

  const handleFindByProductName = (name: string) => {
    dispatch(findByProductName(name));
  };

  const handleSelectedCategory = (categories: SelectedCategory[]) => {
    dispatch(setSelectedCategory(categories));
  };

  const handleSelectedBrands = (brands: SelectedBrand[]) => {
    dispatch(setSelectedBrands(brands));
  };

  const handleSelectedPrice = (price: { min: number; max: number }) => {
    dispatch(setSelectedPrice(price));
  };

  const handleResetFilters = () => {
    router.push("?");
    dispatch(resetFilters());
  };

  return {
    // State
    filters: filterState.filters,
    order: filterState.order,
    pagination: filterState.pagination,
    productName: filterState.productName,
    filterOpen: filterState.filterOpen,
    sidebarpopup: filterState.sidebarpopup,
    leftSidebarOpen: filterState.leftSidebarOpen,
    selectedCategory: filterState.selectedCategory,
    selectedBrands: filterState.selectedBrands,
    selectedPrice: filterState.selectedPrice,
    filtersModified: filterState.filtersModified,

    // Actions
    handlePagination,
    handleProductName,
    handleUpdateFilters,
    handleUpdateOrder,
    handleFindByProductName,
    handleFilterOpen,
    handleLeftSidebarOpen,
    handleSidebarpopup,
    handleSelectedCategory,
    handleSelectedBrands,
    handleSelectedPrice,
    handleResetFilters,
  };
};
